import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import UiHorizontalScroll from "./UiHorizontalScroll.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UiTabs',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiHorizontalScroll, _mergeProps(_ctx.$attrs, { style: {"margin-bottom":"16px"} }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})